import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import BTirDesPontsSoutenirDesVies from "./sections/BTirDesPontsSoutenirDesVies";
import NosPiliersDAction from "./sections/NosPiliersDAction";
import LEssenceDeNotreMission from "./sections/LEssenceDeNotreMission";
import ChiffresClSDeNotreImpact from "./sections/ChiffresClSDeNotreImpact";
import VoixDeLaCommunaut from "./sections/VoixDeLaCommunaut";
import RejoignezLeMouvement from "./sections/RejoignezLeMouvement";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      {}
      <BTirDesPontsSoutenirDesVies />
      
      {}
      <NosPiliersDAction />
      
      {}
      <LEssenceDeNotreMission />
      
      {}
      <ChiffresClSDeNotreImpact />
      <VoixDeLaCommunaut />
      <RejoignezLeMouvement />
      
      <Footer />
    </div>;
}